import React from "react";
import { useNavigate } from "react-router-dom";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { motion } from "framer-motion";
import mainImg from "../../static/media/main.webp";

// Se actualiza la paleta para que coincida con el Navbar
const C = {
  darkBlue: "#0057A8",
  cream: "#F8F6F0",
  creamDark: "#E6E2D6",
  white: "#ffffff",
};

export default function HeroSection() {
  const navigate = useNavigate();

  return (
    <Box
      id="inicio"
      component={motion.section}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.9 }}
      sx={{
        position: "relative",
        overflow: "hidden",
        display: "flex",
        flexDirection: "column",
        pt: { xs: "80px", md: "110px" }, // Aumentado un poco el padding top para compensar el navbar flotante
        minHeight: "100vh",
        background: C.cream, // Fondo base adaptado
        boxSizing: "border-box",
      }}
    >
      {/* Imagen de fondo limpia */}
      <Box
        component="img"
        src={mainImg}
        alt=""
        aria-hidden="true"
        sx={{
          position: "absolute",
          inset: 0,
          width: "100%",
          height: "100%",
          objectFit: "cover",
          objectFit: "cover",
          // Desplazamos la imagen a la derecha en móvil para que salga la chica
          objectPosition: { xs: "55% center", md: "center top" },
          zIndex: 0,
        }}
      />

      <Box
        sx={{
          position: "relative",
          zIndex: 2,
          flex: 1,
          display: "flex",
          alignItems: "center",
          width: "100%",
          maxWidth: "1140px",
          mx: "auto",
          px: { xs: "20px", sm: "32px", md: "40px" },
          py: { xs: "48px", md: "64px" },
          pb: { xs: "80px", md: "100px" },
          boxSizing: "border-box",
        }}
      >
        <Box sx={{ maxWidth: { xs: "100%", md: "650px" }, width: "100%" }}>
          {/* TÍTULO DIRECTO Y CORPORATIVO */}
          <Typography
            variant="h1"
            component={motion.h1}
            initial={{ opacity: 0, y: 24 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.15 }}
            sx={{
              color: C.darkBlue,
              fontWeight: 750,
              fontSize: { xs: "36px", sm: "46px", md: "40px" },

              lineHeight: 1.1,
              letterSpacing: "-.02em",
              mb: "20px",
              // Sombra blanca sutil para asegurar la legibilidad sobre la imagen
              textShadow: "0px 2px 8px rgba(255, 255, 255, 0.9)",
            }}
          >
            Venta directa de{" "}
            <Box component="span" sx={{ color: C.darkBlue }}>
              material eléctrico
            </Box>
            <br />
            <Box
              component="span"
              sx={{
                color: "#000000", // o el color que desees
                fontWeight: 700,
                fontSize: { xs: "20px", sm: "32px", md: "42px" },
              }}
            >
              para proyectos de todos los tamaños
            </Box>
          </Typography>

          {/* PÁRRAFO DESCRIPTIVO */}
          <Typography
            component={motion.p}
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.28 }}
            sx={{
              color: "#333333",
              fontSize: { xs: "16px", md: "18px" },
              lineHeight: 1.6,
              maxWidth: "540px",
              mb: "36px",
              fontWeight: 700,
              // Fondo semitransparente por si la imagen tiene elementos que choquen con el texto
              background: "rgba(248, 246, 240, 0.40)",
              padding: "12px 16px",
              borderRadius: "12px",
              backdropFilter: "blur(4px)",
            }}
          >
            Distribuimos insumos eléctricos y ferreteros de las mejores marcas.
            Nuestro catálogo abarca soluciones integrales para el sector
            industrial, comercial y residencial.
          </Typography>

          <Box
            component={motion.div}
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "14px",
              flexWrap: "wrap",
            }}
          >
            {/* BOTÓN PRIMARIO ESTILO NAVBAR */}
            <Box
              component="button"
              onClick={() =>
                window.open(
                  "https://api.whatsapp.com/send/?phone=593999943920&text&type=phone_number&app_absent=0",
                  "_blank",
                  "noopener,noreferrer",
                )
              }
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: "9px",
                background: C.darkBlue,
                border: "none",
                borderRadius: "50px",
                px: { xs: "24px", md: "30px" },
                py: "14px",
                fontSize: "13px",
                fontWeight: 700,
                color: C.cream,
                cursor: "pointer",
                letterSpacing: ".05em",
                textTransform: "uppercase",
                transition: "opacity .2s, transform .15s",
                "&:hover": {
                  opacity: 0.9,
                  transform: "translateY(-2px)",
                },
              }}
            >
              <Box
                component="svg"
                viewBox="0 0 24 24"
                sx={{
                  width: 17,
                  height: 17,
                  fill: "none",
                  stroke: C.cream,
                  strokeWidth: 2.2,
                  strokeLinecap: "round",
                }}
              >
                <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 015.11 12.84 19.79 19.79 0 012.04 4.18 2 2 0 014 2h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L8.09 9.91a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z" />
              </Box>
              Cotizar ahora
            </Box>

            {/* BOTÓN SECUNDARIO ESTILO NAVBAR */}
            <Box
              component="button"
              onClick={() => {
                navigate("/tienda");
                window.scrollTo(0, 0);
              }}
              sx={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                background: C.creamDark,
                border: "none",
                borderRadius: "50px",
                px: { xs: "20px", md: "26px" },
                py: "14px",
                fontSize: "13px",
                fontWeight: 700,
                color: C.darkBlue,
                cursor: "pointer",
                letterSpacing: ".02em",
                transition: "background .2s, transform .15s",
                "&:hover": {
                  background: "#d6d2c4", // Tono ligeramente más oscuro que el creamDark
                  transform: "translateY(-2px)",
                },
              }}
            >
              <Box
                component="svg"
                viewBox="0 0 24 24"
                sx={{
                  width: 16,
                  height: 16,
                  fill: "none",
                  stroke: "currentColor",
                  strokeWidth: 2,
                  strokeLinecap: "round",
                }}
              >
                <rect x="2" y="3" width="20" height="14" rx="2" />
                <line x1="8" y1="21" x2="16" y2="21" />
                <line x1="12" y1="17" x2="12" y2="21" />
              </Box>
              Ver productos
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
